import styled from 'styled-components'
import { Card, getPaletteColor } from 'pcln-design-system'

const Wrapper = styled(Card)`
  &&& {
    border: none;
  }
  display: flex;
  justify-content: center;
  ${(props) => props.theme.mediaQueries.xl} {
    background: ${getPaletteColor('background.light')} !important;
    border: solid ${getPaletteColor('border.base')} 1px;
  }
`

export { Wrapper }
